export class CommentProductModel {
    Comment: string;
    FullName: string;
    Qualification: number;
    Rating: number;
    UserEmail: string;

    constructor() {
        this.Comment = '';
        this.FullName = '';
        this.Qualification = 0;
        this.Rating = 0;
        this.UserEmail = '';
    }
  }
